import { Fragment, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Box, Container } from '@material-ui/core';
import { RootState } from 'store/reducer';
import useCadastroSteps from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/hooks/useEscolaSteps';
import { TimelineItem } from './TimelineItem';
import { ESCOLA_ETAPAS_PARAMS_URL } from 'models/escola';
import { TimelineProps } from './__types';
import './styles.scss';
import { useParams } from 'react-router-dom';
import { SchoolEditParams } from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/__types';

export const Timeline = ({ items, renderForm }: TimelineProps) => {
  const { getTimelineItemIndex, changeTab } = useCadastroSteps();
  const currentTab = useSelector(
    (state: RootState) => state.escolas.currentTab
  );
  const { id } = useParams<SchoolEditParams>();

  const verificaFluxo = useCallback((idStep) => {
    if (!location.pathname.includes(ESCOLA_ETAPAS_PARAMS_URL.CADASTRO)) {
      changeTab(id, idStep);
    }
  }, [changeTab, id]);

  return (
    <Container className='container' style={{ marginTop: '1.87rem' }}>
      <Box display='flex' flexDirection='column' alignItems='center'>
        <Box className='timeline-container'>
          {items.map((item, index) => (
            <Fragment key={item.id}>
              <TimelineItem
                id={item.id}
                icon={item.icon}
                isActive={item.id === currentTab}
                isCompleted={index < getTimelineItemIndex(items)}
                label={item.label}
                isSecond={index === 1}
                isThird={index === 2}
                onClick={() => verificaFluxo(item.id)}
              />
              {index < items.length - 1 && (
                <Box className='line-container'>
                  <Box
                    className={`line ${index < getTimelineItemIndex(items) ? 'active-line' : ''
                      }`}
                  />
                </Box>
              )}
            </Fragment>
          ))}
        </Box>
        {renderForm(currentTab)}
      </Box>
    </Container>
  );
};
